// extracted by mini-css-extract-plugin
module.exports = {"switch_container":"OnlyMyFacilitySwitch_switch_container__4Ntw8","switch_description":"OnlyMyFacilitySwitch_switch_description__ox_BG"};